import React, { useState, useRef, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

// import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'

import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import FilledInput from '@material-ui/core/FilledInput'
import TextField from '@material-ui/core/TextField'
import InputAdornment from '@material-ui/core/InputAdornment'

import Accordion from '@material-ui/core/Accordion'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import PublishIcon from '@material-ui/icons/Publish'

import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'

import Switch from '@material-ui/core/Switch'
import Button from '@material-ui/core/Button'
import Cancel from '@material-ui/icons/Cancel'
import Avatar from '@material-ui/core/Avatar'
import { withStyles, makeStyles } from '@material-ui/core/styles'

import { updateUserGeneralSettings, updateUserAvatar, getUserGeneralSettings, getAlerts, subscribeToAlert } from '../../../../redux/actions'

import { NotificationToast, BaseToast } from '../../tools/Toast'
import { updateUserPassword, handleTextPrepper, handlePhonePrepper, ValidateEmail, ValidatePhone, Toast, keyify2 } from '../../../../utils'
import { statusFilterDetails, statusTypes, statusPermissions } from '../../../../utils/variables'
import ResetPassword from '../../modals/ResetPassword'

import { PhoneMask, EmailMask } from '../../tools/TextMasks'

const StyledSwitch = withStyles({
  switchBase: {
    color: 'white',
    '&$checked': {
      color: '#A4D164'
    },
    '&$checked + $track': {
      backgroundColor: '#A4D164'
    }
  },
  checked: {},
  track: {}
})(Switch)

const useStyles = makeStyles((theme) => ({
  blueBtn: {
    backgroundColor: '#3984f7',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#0651C4'
    }
  },
  greenBtn: {
    color: '#fff',
    backgroundColor: '#A4D164',
    '&:hover': {
      backgroundColor: '#8AB651'
    }
  },
  heading: {
  },
  subHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
    textTransform: 'none'
  },
  generalFields: {
    width: '100%'
  },
  phoneInput: {
    width: '100%'
  },
  roleContent: {
    width: '80%'
  },
  accordionDetails: {
    textTransform: 'none',
    color: theme.palette.text.secondary
  },
  alertCard: {
    height: '4em'
  },
  uploadInput: {
    display: 'none'
  },
  imageNameAvatar: {
    background: theme.palette.background.paper,
    '&:hover': {
      background: theme.palette.background.default
    },
    '&.Mui-focused': {
      background: theme.palette.background.default
    }
  }
}))

const useTextStyles = makeStyles((theme) => ({
  root: {
    overflow: 'hidden',
    backgroundColor: '#fff',
    width: '100%',
    '&:hover': {
      backgroundColor: '#f5f5f5'
    },
    '&$focused': {
      backgroundColor: '#f5f5f5 !important'
    }
  },
  focused: {}
}))

const useSelectStyles = makeStyles((theme) => ({
  select: {
    overflow: 'hidden',
    backgroundColor: '#fff',
    width: '100%',
    borderTopLeftRadius: '4px',
    borderTopRightRadius: '4px',
    transition: 'background-color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
    '&:focus': {
      backgroundColor: '#f5f5f5'
    },
    '&:hover': {
      backgroundColor: '#f5f5f5'
    }
  }
}))

/**
 * Returns user general info modal
 */
const UserGeneral = ({ setSelectedForm }) => {
  const dispatch = useDispatch()
  const classes = useStyles()
  const textClasses = useTextStyles()
  const selectClasses = useSelectStyles()

  const fileInput = useRef()

  const settings = useSelector(state => state.userSettings.general)
  const { token, supervisorID, accountId, assignedRole, permissions = [] } = useSelector(state => state.auth)
  const { userRoles } = useSelector(state => state.userRoles)

  const [tempImage, setTempImage] = useState('')
  const [imageName, setImageName] = useState('')
  const [showAvatarInput, setShowAvatarInput] = useState(false)

  const orgSmsEnabled = useSelector(state => state.orgSettingsSettings.general.enableSMS)

  const userRole = userRoles.find((role) => { return role.roleID === assignedRole })
  const hasUnviewedPermission = Boolean(userRole?.rolePermissions.find(perm => perm.permissionKey === statusPermissions[statusTypes.UNVIEWED]))

  const settingsForm = {
    firstName: settings.firstName,
    lastName: settings.lastName,
    jobTitle: settings.jobTitle == null ? '' : settings.jobTitle,
    cellPhone: settings.cellPhone == null ? '' : settings.cellPhone,
    officePhone: settings.officePhone == null ? '' : settings.officePhone,
    samePhone: settings.samePhone,
    emailAddress: settings.emailAddress == null ? '' : settings.emailAddress,
    enableSMS: settings.enableSMS,
    defaultPage: settings.defaultPage,
    defaultReport: settings.defaultReport,
    defaultView: settings.defaultView,
    defaultCaptureCount: settings.defaultCaptureCount,
    avatarKey: settings.avatarKey,
    avatarPath: settings.avatarPath
  }

  const [form, setForm] = useState(settingsForm)
  const [passwordModal, setPasswordModal] = useState(false)
  const [expandRole, setExpandRole] = useState(false)

  const TreeData = useSelector(state => state.auth.unitTree)
  const Alerts = useSelector(state => state.alerts.alerts)

  // This is currently being used to capture the unit tree information to get the alerts
  const data = keyify2(TreeData)
  const [selectedKeys] = useState(data)

  // Bring in information from API to populate Alerts
  useEffect(() => {
    dispatch(getAlerts(selectedKeys[0]))
  }, [dispatch, selectedKeys])

  const unSubscribeAlert = (notificationID) => {
    const unitsToDelete = []
    if (Alerts.global.findIndex(x => x.emailNotificationID === notificationID) !== -1) {
      Alerts.global.forEach((alert) => {
        if (alert.emailNotificationID === notificationID) {
          alert.subscribed.units.forEach((unit) => {
            unitsToDelete.push(unit.unitID)
          })
        }
      })
    }
    if (Alerts.supervisor.findIndex(x => x.emailNotificationID === notificationID) !== -1) {
      Alerts.supervisor.forEach((alert) => {
        if (alert.emailNotificationID === notificationID) {
          alert.subscribed.units.forEach((unit) => {
            unitsToDelete.push(unit.unitID)
          })
        }
      })
    }
    if (Alerts.unit.findIndex(x => x.emailNotificationID === notificationID) !== -1) {
      Alerts.unit.forEach((alert) => {
        if (alert.emailNotificationID === notificationID) {
          alert.subscribed.units.forEach((unit) => {
            unitsToDelete.push(unit.unitID)
          })
        }
      })
    }
    const unitID = selectedKeys[0]
    const prefrences = {
      emailNotificationID: notificationID,
      unitsToAdd: [],
      unitsToDelete,
      sendSMS: false,
      sendEmail: false,
      isSubscribed: false
    }
    dispatch(subscribeToAlert(unitID, prefrences, fireUnSubscribeSuccess, fireUnSubscribeFailure))
  }

  const fireUnSubscribeSuccess = () => {
    NotificationToast(false, 'Successfully Updated Alert Prefrences!')
    dispatch(getAlerts(selectedKeys[0]))
  }

  const fireUnSubscribeFailure = () => {
    NotificationToast(true, 'Failed to update alert prefrences.')
  }

  // Gets the list of the alerts the user has subscribed too and populates them in a series of cards
  const getSubscribed = (alerts) => {
    const newSubscribed = []
    if (alerts && Object.keys(alerts).length !== 0) {
      alerts.global.map((alert) => {
        if (alert.subscribed.isSubscribed) {
          newSubscribed.push(alert)
        }
        return false
      })
      alerts.supervisor.map((alert) => {
        if (alert.subscribed.isSubscribed) {
          newSubscribed.push(alert)
        }
        return false
      })
      alerts.unit.map((alert) => {
        if (alert.subscribed.isSubscribed) {
          newSubscribed.push(alert)
        }
        return false
      })

      return (newSubscribed.length !== 0
        ? (newSubscribed.map((alert) => {
          return (
            <Card key={`alert-${alert.emailNotificationID}`} className={`${classes.alertCard} mb-2`}>
              <CardContent className='p-1 ml-2 mt-2'>
                <Grid container direction='row' spacing={2} style={{ textTransform: 'none' }} alignItems='center'>
                  <Grid item xs={1}>
                    <Typography
                      className='text-primary font-weight-bold mr-2' variant='subtitle1'
                    >
                      Title:
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <Typography variant='subtitle2' style={{ textTransform: 'none' }} className='text-break text-muted font-weight-bold pl-0'>
                      {alert.emailNotificationName}
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Button
                      variant='contained'
                      size='small'
                      className={classes.greenBtn}
                      onClick={() => { unSubscribeAlert(alert.emailNotificationID) }}
                    >
                      Unsubscribe
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          )
        }))
        : (
          <Card className={`${classes.alertCard} mb-2`}>
            <CardContent style={{ display: 'flex', justifyContent: 'center' }}>
              <Typography variant='overline' className='text-muted' style={{ textTransform: 'none' }}> {hasUnviewedPermission ? 'None Subscribed. Select Manage to Add New Alerts.' : 'Your user permissions do not allow for alert subscriptions.'}</Typography>
            </CardContent>
          </Card>)
      )
    }
    return false
  }

  const goToManage = () => {
    // take them to the mangage page
    setSelectedForm('manage-alerts')
  }

  const onChange = (prop) => e => {
    setForm({ ...form, [prop]: e.target.value })
  }

  const toggleSmsNotifications = () => {
    const newForm = { ...form }
    newForm.enableSMS = !newForm.enableSMS
    setForm(newForm)
  }

  const toggleSamePhone = () => {
    const newForm = { ...form }
    newForm.samePhone = !newForm.samePhone
    setForm(newForm)
  }

  const handleImageChange = (e) => {
    e.preventDefault()
    const file = e.target.files[0]
    // 2mb file size 2097152
    if (file.size > 2097152) {
      Toast.fire({
        icon: 'info',
        title: 'The selected file is too large.'
      })
    } else {
      setImageName(file.name)
      const reader = new window.FileReader()
      reader.readAsDataURL(file)
      reader.onloadend = () => {
        // const newForm = { ...form }
        // newForm.avatarKey = reader.result
        // setForm(newForm)
        setTempImage(reader.result)
        // handleSubmit()
      }
    }
  }

  const submitAvatarUpdate = async () => {
    const avatar = tempImage
    dispatch(updateUserAvatar(avatar, fireAvatarUpdateSuccess, fireAvatarUpdateFailure))
  }

  const fireAvatarUpdateSuccess = () => {
    // NotificationToast(false, 'Avatar updated successfully! Changes will be reflected shortly.')
    BaseToast('success', 'Avatar updated successfully! Changes will be reflected shortly.')
    setTempImage('')
    setImageName('')
    setShowAvatarInput(!showAvatarInput)
    setTimeout(() => {
      dispatch(getUserGeneralSettings())
    }, 20000)
  }

  const fireAvatarUpdateFailure = () => {
    // NotificationToast(true, 'Failed to update avatar.')
    setTempImage('')
    setImageName('')
    setShowAvatarInput(!showAvatarInput)
    BaseToast('error', 'Failed to update avatar.')
  }

  const submitForm = async () => {
    const runTimeError = !ValidateEmail(form.emailAddress) || form.firstName.length === 0 || form.lastName.length === 0 || form.emailAddress.length === 0 ||
      (!ValidatePhone(form.officePhone) && form.officePhone !== '') || (!ValidatePhone(form.cellPhone) && form.cellPhone !== '')

    if (runTimeError) {
      NotificationToast(false, 'Error with required fields!', true)
    } else {
      const settings = Object.assign({}, form)
      settings.enableSMS = settings.enableSMS ? 1 : 0
      settings.firstName = handleTextPrepper(settings.firstName)
      settings.lastName = handleTextPrepper(settings.lastName)
      settings.jobTitle = handleTextPrepper(settings.jobTitle)
      // settings.emailAddress = handleTextPrepper(settings.emailAddress)
      settings.defaultPage = handleTextPrepper(settings.defaultPage)
      settings.defaultReport = settings.defaultReport === 'anyStatus' ? 'A' : handleTextPrepper(settings.defaultReport)
      settings.defaultView = handleTextPrepper(settings.defaultView)
      settings.cellPhone = handlePhonePrepper(settings.cellPhone)
      settings.officePhone = handlePhonePrepper(settings.officePhone)
      settings.samePhone = settings.samePhone ? 1 : 0
      dispatch(updateUserGeneralSettings(settings, fireUpdateSuccess, fireUpdateFailure))
    }
  }

  const fireUpdateSuccess = () => {
    NotificationToast(false, 'Settings updated successfully!')
  }

  const fireUpdateFailure = () => {
    NotificationToast(true, 'Failed to update settings.')
  }

  const handleResetPassword = async (oldPassword, newPassword, confirmPassword) => {
    if (newPassword === confirmPassword) {
      const status = await updateUserPassword(token, accountId, supervisorID, oldPassword, newPassword)

      if (status === true) {
        NotificationToast(false, 'Password updated successfully!')
        setPasswordModal(false)
        return true
      } else {
        NotificationToast(true, 'Incorrect password entered!')
        return false
      }
    } else {
      NotificationToast(true, 'Passwords do not match!')
      return false
    }
  }

  const handleOnReset = async (e) => {
    e.preventDefault()
    setPasswordModal(true)
  }

  const handleAccordionChange = () => {
    setExpandRole(!expandRole)
  }

  const isEnabled = form.firstName !== settings.firstName || form.lastName !== settings.lastName ||
    form.enableSMS !== settings.enableSMS || form.jobTitle !== settings.jobTitle || form.cellPhone !== settings.cellPhone ||
    form.officePhone !== settings.officePhone || form.samePhone !== settings.samePhone || form.emailAddress !== settings.emailAddress ||
    form.defaultPage !== settings.defaultPage || form.defaultReport !== settings.defaultReport || form.defaultView !== settings.defaultView ||
    form.defaultCaptureCount !== settings.defaultCaptureCount

  const avatarInput = () => {
    if (showAvatarInput === true) {
      return (
        <>
          <Grid item container direction='row' justify='center'>
            <Grid item>
              <Typography variant='caption' component='p' className='text-muted' align='center'>
                Upload limit: 2mb
              </Typography>
            </Grid>
          </Grid>

          <Grid item container direction='row' justify='center' style={{ marginBottom: '10px' }}>
            <Grid item>
              <Typography variant='caption' component='p' className='text-muted' align='center'>
                Image Ratio: 500 x 500
              </Typography>
            </Grid>
          </Grid>

          <Grid item container direction='row' justify='center'>
            <Grid item xs={10}>
              <input
                accept='image/*'
                className={classes.uploadInput}
                id='account-upload'
                multiple
                type='file'
                ref={fileInput}
                onChange={(e) => handleImageChange(e)}
              />
              <label htmlFor='account-upload' className='w-100'>
                <FilledInput
                  value={imageName}
                  className={classes.imageNameAvatar}
                  fullWidth
                  readOnly
                  endAdornment={
                    <InputAdornment position='end'>
                      <Button variant='contained' color='primary' component='span' className={classes.button}>
                        <PublishIcon />
                      </Button>
                    </InputAdornment>
                  }
                />
              </label>
            </Grid>
          </Grid>

          {/* <Col sm={12}>
            <input
              accept='image/*'
              className='custom-file-input'
              style={{
                marginBottom: '20px'
              }}
              id='customFile'
              type='file'
              ref={fileInput}
              onChange={(e) => handleImageChange(e)}
            />
            <label className='custom-file-label upload-form-text' htmlFor='customFile'>
              {imageName}
            </label>
          </Col> */}

          <Grid item container direction='row' justify='center'>
            <Button
              variant='contained'
              className={classes.greenBtn}
              style={{ marginRight: '20px' }}
              onClick={(e) => { e.preventDefault(); setShowAvatarInput(!showAvatarInput); setTempImage(''); setImageName('') }}
            >
              <Cancel />
            </Button>
            <Button
              variant='contained'
              className={classes.blueBtn}
              onClick={(e) => { e.preventDefault(); submitAvatarUpdate() }}
            >
              Save
            </Button>
          </Grid>
        </>
      )
    } else {
      return (
        <>
          <Button
            variant='contained'
            className={classes.greenBtn}
            onClick={(e) => { e.preventDefault(); setShowAvatarInput(!showAvatarInput); setTempImage(''); setImageName('') }}
          >
            Change Avatar
          </Button>

          {
            orgSmsEnabled === 1
              ? (
                <>
                  <Button
                    variant='contained'
                    onClick={handleOnReset}
                    className={`${classes.greenBtn} mt-5`}
                  >
                    Reset Password
                  </Button>
                </>
              )
              : (
                <>
                </>)
          }

        </>
      )
    }
  }

  return (
    <>
      <Grid container direction='column' justify='flex-start' spacing={2} className='mx-auto'>
        <Grid container item direction='row' className='w-100 mx-auto'>
          <Grid item container xs={8} justify='flex-start'>
            <h2>
              My Settings
            </h2>
          </Grid>

          <Grid item container xs={4} justify='center'>
            <Button
              className={classes.blueBtn}
              disabled={!isEnabled}
              variant='contained'
              size='large'
              onClick={submitForm}
            >
              Save
            </Button>
          </Grid>
        </Grid>

        <Grid container item direction='row' className='mt-3 w-100 mx-auto' justify='space-evenly'>
          <Grid container item xs={8} direction='column' spacing={5}>

            <Grid container item direction='row' spacing={2}>
              <Grid item xs={6}>
                <TextField
                  label='First Name'
                  required
                  name='firstName'
                  variant='filled'
                  error={form.firstName.length === 0}
                  value={form.firstName ? form.firstName : ''}
                  onChange={onChange('firstName')}
                  InputProps={{
                    classes: textClasses
                  }}
                  fullWidth
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  label='Last Name'
                  name='lastName'
                  required
                  variant='filled'
                  error={form.lastName.length === 0}
                  value={form.lastName ? form.lastName : ''}
                  onChange={onChange('lastName')}
                  InputProps={{
                    classes: textClasses
                  }}
                  fullWidth
                />
              </Grid>
            </Grid>

            <Grid container item direction='row' spacing={2}>
              <Grid item xs={6}>
                <TextField
                  label='Job Title'
                  name='jobTitle'
                  variant='filled'
                  value={form.jobTitle ? form.jobTitle : ''}
                  onChange={onChange('jobTitle')}
                  InputProps={{
                    classes: textClasses
                  }}
                  fullWidth
                />
              </Grid>

              <Grid item xs={6}>
                <FormControl fullWidth>
                  <InputLabel
                    htmlFor='email-input'
                    variant='filled'
                    required
                  >
                    Email
                  </InputLabel>
                  <FilledInput
                    id='email-input'
                    name='emailInput'
                    // onChange={onChange('emailAddress')}
                    value={form.emailAddress ? form.emailAddress : ''}
                    color='primary'
                    required
                    error={!ValidateEmail(form.emailAddress)}
                    // className={classes.phoneInput}
                    classes={textClasses}
                    fullWidth
                    inputComponent={EmailMask}
                    disabled
                  />
                </FormControl>
              </Grid>
            </Grid>

            <Grid container item direction='row' spacing={2}>
              <Grid item xs={6}>
                <FormControl fullWidth>
                  <InputLabel htmlFor='officePhone-input' variant='filled'>Office Phone Number</InputLabel>
                  <FilledInput
                    id='officePhone-input'
                    name='phoneInput'
                    onChange={onChange('officePhone')}
                    value={form.officePhone ? form.officePhone : ''}
                    error={!ValidatePhone(form.officePhone) && form.officePhone.length !== 0}
                    color='primary'
                    // className={classes.phoneInput}
                    classes={textClasses}
                    fullWidth
                    inputComponent={PhoneMask}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={6}>
                <FormControl fullWidth>
                  <InputLabel htmlFor='cellPhone-input' variant='filled'>Mobile Phone Number</InputLabel>
                  <FilledInput
                    id='cellPhone-input'
                    name='phoneInput'
                    onChange={onChange('cellPhone')}
                    value={form.cellPhone ? form.cellPhone : ''}
                    error={!ValidatePhone(form.cellPhone) && form.cellPhone.length !== 0}
                    color='primary'
                    // className={classes.phoneInput}
                    classes={textClasses}
                    fullWidth
                    inputComponent={PhoneMask}
                    disabled={!!form.samePhone}
                  />
                </FormControl>
              </Grid>
            </Grid>

            <Grid container item direction='row' spacing={2}>
              <Grid item xs={6} container direction='column'>
                <Grid item>
                  <Typography variant='body1' component='label' style={{ fontSize: '.9rem' }}>Mobile Number Same As Office</Typography>
                </Grid>
                <Grid item>
                  <FormControlLabel
                    control={
                      <StyledSwitch
                        checked={!!form.samePhone}
                        onChange={toggleSamePhone}
                      />
                    }
                    label={form.samePhone ? <span>Yes</span> : <span>No</span>}
                  />
                </Grid>
              </Grid>

              <Grid item xs={6} container direction='column'>
                {
                  orgSmsEnabled === 1
                    ? (
                      <>
                        <Grid item>
                          <Typography variant='body1' component='label' style={{ fontSize: '.9rem' }}>Enable SMS Notifications</Typography>
                        </Grid>
                        <Grid item>
                          <FormControlLabel
                            control={
                              <StyledSwitch
                                checked={!!form.enableSMS}
                                onChange={toggleSmsNotifications}
                              />
                            }
                            label={form.enableSMS ? <span>Yes</span> : <span>No</span>}
                          />
                        </Grid>
                      </>
                    )
                    : (
                      <>
                        <Grid item container direction='row' alignItems='center' justify='center'>
                          <Button
                            variant='contained'
                            onClick={handleOnReset}
                            style={{ width: '80%' }}
                            className={`${classes.greenBtn}`}
                          >
                            Reset Password
                          </Button>
                        </Grid>
                      </>
                    )
                }
              </Grid>

              {/* <Grid item xs={4}>
                <Button
                  variant='contained'
                  onClick={handleOnReset}
                  className={classes.greenBtn}
                >
                  Reset Password
                </Button>
              </Grid> */}
            </Grid>
          </Grid>

          <Grid container item xs={4} direction='column' justify='flex-start' className='pr-0' spacing={1}>
            {/* Just needs avatar key path set */}
            {/* <img src={form.avatarKey ? form.avatarKey : <AccountCircle className='massiveIcon' />} /> */}
            <Grid item className='mx-auto'>
              <Avatar
                src={
                  tempImage.length > 0 ? tempImage : settings && settings.avatarPath ? `${settings.avatarPath}?${new Date().getTime()}` : ''
                }
                style={{
                  marginBottom: '5px',
                  width: '190px',
                  height: '190px'
                }}
              />
            </Grid>

            {/* <Grid item container direction='row' justify='center'>
              {avatarInput()}
            </Grid> */}

            <Grid item container direction='row' justify='center'>
              {avatarInput()}
            </Grid>

          </Grid>
        </Grid>

        <Grid container item direction='row' className='my-3 w-100 mx-auto'>
          <Grid container item direction='column' spacing={1} className='w-100 mx-auto'>
            <Grid item>
              <Typography variant='body1' component='p'>
                My Role
              </Typography>
            </Grid>

            <Grid item className='w-100 pr-5'>
              <Accordion expanded={expandRole} onChange={handleAccordionChange} className='w-100'>
                <AccordionSummary
                  className='w-100'
                  classes={{ content: classes.roleContent }}
                  expandIcon={<ExpandMoreIcon />}
                >
                  <Grid container item direction='row' className='w-100 mr-auto' alignItems='center' xs={11}>
                    <Grid item xs={6}>
                      <Typography variant='h6' className={`${classes.heading} text-primary font-weight-bold text-capitalize`}>
                        {userRoles.length ? userRoles.find((role) => role.roleID === assignedRole).roleName : ''}
                      </Typography>
                    </Grid>
                    {
                      expandRole === false
                        ? (

                          <Grid item xs={5}>
                            <Typography className={`${classes.subHeading} text-truncate`}>
                              {userRoles.length ? userRoles.find((role) => role.roleID === assignedRole).roleDesc : ''}
                            </Typography>
                          </Grid>
                        )
                        : (
                          <></>
                        )
                    }
                  </Grid>
                </AccordionSummary>

                <AccordionDetails>
                  <Typography className={`text-break ${classes.accordionDetails}`}>
                    {userRoles.length ? userRoles.find((role) => role.roleID === assignedRole).roleDesc : ''}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </Grid>

          </Grid>
        </Grid>

        <Grid container item direction='row' className='w-100 mx-auto'>
          <Grid container item direction='column' spacing={1}>
            <Grid item container>
              <Typography variant='body1' component='p' className='text-bold'>
                My Preferences
              </Typography>
            </Grid>

            <Grid item container direction='row' spacing={2} className='w-100 mx-auto pr-5'>
              <Grid item xs={3}>
                <FormControl fullWidth>
                  <InputLabel htmlFor='default-page-input-label' variant='filled'>Initial Start Page</InputLabel>
                  <Select
                    value={form.defaultPage}
                    onChange={onChange('defaultPage')}
                    id='default-page-input'
                    labelId='default-page-input-label'
                    variant='filled'
                    classes={selectClasses}
                  >
                    <MenuItem value='C'>Captures</MenuItem>
                    <MenuItem value='D'>Dashboard</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={3}>
                <FormControl fullWidth>
                  <InputLabel htmlFor='default-report-input-label' variant='filled'>Default Capture Report</InputLabel>
                  <Select
                    value={form.defaultReport}
                    onChange={onChange('defaultReport')}
                    id='default-report-input'
                    labelId='default-report-input-label'
                    variant='filled'
                    classes={selectClasses}
                  >
                    <MenuItem value={statusTypes.ALL_CAPTURES}>All Captures</MenuItem>
                    {statusFilterDetails.map(statusObj => {
                      const { statusLabel, statusValue, statusPermission } = statusObj
                      const optionIsDisabled = Boolean(permissions?.length && !permissions.includes(statusPermission))
                      return (
                        <MenuItem key={`status-capture-${statusValue}`} disabled={optionIsDisabled} value={statusValue}>{statusLabel}</MenuItem>
                      )
                    })}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={3}>
                <FormControl fullWidth>
                  <InputLabel htmlFor='default-view-input-label' variant='filled'>Default Capture View</InputLabel>
                  <Select
                    value={form.defaultView}
                    onChange={onChange('defaultView')}
                    id='default-view-input'
                    labelId='default-view-input-label'
                    variant='filled'
                    classes={selectClasses}
                  >
                    <MenuItem value='D'>Detail</MenuItem>
                    <MenuItem value='G'>Grid</MenuItem>
                    <MenuItem value='L'>List</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={3}>
                <FormControl fullWidth>
                  <InputLabel htmlFor='default-count-input-label' variant='filled'> Default Capture Count</InputLabel>
                  <Select
                    value={form.defaultCaptureCount}
                    onChange={onChange('defaultCaptureCount')}
                    id='default-count-input'
                    labelId='default-count-input-label'
                    variant='filled'
                    classes={selectClasses}
                  >
                    <MenuItem value='10'>10</MenuItem>
                    <MenuItem value='25'>25</MenuItem>
                    <MenuItem value='50'>50</MenuItem>
                    <MenuItem value='100'>100</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

            </Grid>
          </Grid>
        </Grid>
        <Grid container item direction='row' className='my-3 w-100 mx-auto'>
          <Grid container item direction='column' spacing={3}>
            <Grid item container direction='row' spacing={2} alignItems='center'>
              <Grid item>
                <Typography>
                  Subscribed Alerts
                </Typography>
              </Grid>

              {hasUnviewedPermission &&
                <Grid item>
                  <Button
                    variant='contained'
                    className={classes.greenBtn}
                    onClick={goToManage}
                  >
                    Manage
                  </Button>
                </Grid>}
            </Grid>
            <Grid item container direction='row'>
              <Grid item container direction='column' className='pr-5'>
                {
                  Alerts ? Object.keys(Alerts).length ? getSubscribed(Alerts) : (<></>) : (<></>)
                }
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid container item direction='row' justify='flex-end' className='w-100 mx-auto'>
          <Grid item xs={8} />
          <Grid item xs={4} container direction='row' justify='center'>
            <Button
              className={classes.blueBtn}
              disabled={!isEnabled}
              size='large'
              variant='contained'
              onClick={submitForm}
            >
              Save
            </Button>
          </Grid>
        </Grid>

      </Grid>

      <ResetPassword
        passwordCase=''
        passwordModal={passwordModal}
        togglePasswordModal={() => setPasswordModal(false)}
        onResetPassword={handleResetPassword}
      />
    </>
  )
}

export default UserGeneral
